export const GenderData = [
    {
      label: "Male",
      value: "Male",
    },
    {
      label: "Female",
      value: "Female",
    }
   
  ];


  export const IdTypeData = [
    {
      label: "PROMOTIONAL",
      value: "PROMOTIONAL",
    },
    {
      label: "TRANSACTIONAL",
      value: "TRANSACTIONAL",
    }
   
  ];

  export const instTypeData = [
    {
      label: "COMPANY",
      value: "COMPANY",
    },
    {
      label: "INDIVIDUAL",
      value: "INDIVIDUAL",
    } 
  ];
 
  export const ownershipData = [
    {
      label: "I want to share a service code with multiple users",
      value: "SHARED",
    },
    {
      label: "I want my own service code",
      value: "PRIVATE",
    } 
  ];


  export const costData = [
    {
      label: "The Customer",
      value: "CUSTOMER",
    },
    {
      label: "Me, as the owner of the service code",
      value: "ME",
    } 
  ];

  export const userData = [
    {
      label: "KAMAU",
      value: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    }, 
  ];

 
export const recurringBillsData = [
  {
    label: "Electricity",
    value: "Electricity",
  },
  {
    label: "Water",
    value: "Water",
  },
  {
    label: "Security",
    value: "Security",
  }, 
];

export const statusData = [
  {
    label: "Active",
    value: "ACTIVE",
  },
  {
    label: "Inactive",
    value: "INACTIVE",
  }, 
];

export const accessLevelData = [
  {
    label: "User",
    value: "USER",
  },
  {
    label: "Manager",
    value: "MANAGER",
  }, 
  {
    label: "Admin",
    value: "ADMIN",
  }, 
];

export const creditTypeData = [
  {
    label: "NEW",
    value: "NEW",
  },
  {
    label: "REFUND",
    value: "REFUND",
  }
 
];